<template>
  <div class="pdr-20px" >
    <hr
      class="mgl-20px mgr-20px"
      v-if="affectations > 0">
    <p class="center has-text-weight-bold"
      v-if="nbFaceDispo === 0 && affectations === 0" >
      {{$t('optionBlocage.informationOptionBlocage.noDispo')}}
    </p>
    <div v-else class="pd-10px has-text-left mgt-5px columns mgb-0 is-vcentered">
      <div class="column is-1">
        <div class="legende-square legende-square-libre mgl-20px mgt-10px has-text-centered is-1">
        </div>
      </div>
      <div class="column is-9 is-paddingless mgl-20px">
        <p class="has-text-weight-bold mgb-0">
          {{ $t('optionBlocage.informationOptionBlocage.disponible') }}
        </p>
        <p class="has-text-default is-size-7">
          {{ nbFaceDispo }} {{ (nbFaceDispo === 1 || nbFaceDispo === 0)
          ? $t('optionBlocage.informationOptionBlocage.face')
          : $t('optionBlocage.informationOptionBlocage.faces') }}
        </p>
      </div>
      <div :class="{
        'column is-2 has-text-centered' : true,
        'is-clickable': !isLoading,
      }">
      <b-tooltip
            :label="$t(`optionBlocage.informationOptionBlocage.${
              this.showDetail ? 'cacher' : 'voir'
            }`)">
          <qd-button
              v-if="showButton"
              @click="buttonHandler"
              :icon-right="this.showDetail ? 'eye-off' : 'eye'">
          </qd-button>
        </b-tooltip>
      </div>
    </div>
    <div class="my-4 px-4" v-show="showDetail">
      <qd-notification
        class="pd-0 mgb-20px has-background-white"
        :class="{ 'min-height-100': isLoading }"
        ref="element"
        :closable="false">
      <option-blocage-lignes-details-faces
          v-if="!isLoading"
          :lignes="this.lignesDisponibles || []">
      </option-blocage-lignes-details-faces>
      </qd-notification>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import optionBlocageLignesDetailsFaces from '@/components/optionBlocage/optionBlocageLignesDetailsFaces';
import getAll from '@/api/ligneCmdSelProduit';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import moment from 'moment';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'ReseauOptionBlocageLignesDisponible',
  props: {
    affectations: {
      type: Number,
      required: true,
    },
    produitReseau: {
      type: Object,
      default: null,
    },
    idReseau: {
      type: String,
      required: true,
    },
    nbFaceDispo: {
      type: Number,
      required: true,
    },
    anneeSemaine: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lignesAlreadySel: null,
      isLoading: false,
      showDetail: false,
    };
  },
  components: {
    optionBlocageLignesDetailsFaces,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    loading() {
      return this.isLoading || (this.produitReseau === null);
    },
    faceReseau() {
      return this.produitReseau.affectationsReseauFace.filter(face => {
        return moment(this.anneeSemaine, 'YYYYWW').isAfter(moment(face.dateDebut))
        && face.dateFin ? moment(this.anneeSemaine, 'YYYYWW').isBefore(moment(face.dateFin)) : true;
      });
    },
    lignesDisponibles() {
      if (!this.faceReseau || !this.lignesAlreadySel) return null;
      return this.faceReseau.filter(
        face => !this.lignesAlreadySel.map(l => l.produitId).includes(face.produitId),
      ).map(f => {
        f.presence = true;
        return f;
      });
    },
    showButton() {
      return this.nbFaceDispo !== 0;
    },
  },
  methods: {
    async buttonHandler() {
      this.showDetail = !this.showDetail;
      if (this.showDetail && this.lignesDisponibles === null) {
        await this.loadInformations();
      }
    },
    async loadInformations() {
      this.isLoading = true;
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.element.$el,
      });
      try {
        this.lignesAlreadySel = (await getAll({
          limit: NO_PAGINATION,
          query: {
            produitIds: this.produitReseau.affectationsReseauFace.map(face => face.produitId),
            anneeSemaine: this.anneeSemaine,
          },
        })).data.result.items;
        this.isLoading = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>

<style>

</style>
